import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";

function Thankyou() {
  const navigate = useNavigate();
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");

    // Gtag Event snippet for ICICI-Bank-CA-Submit-lead-form conversion page
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-345810612/o6aJCNHZ1pYcELTN8qQB",
        value: 1.0,
        currency: "INR",
      });

      // Event snippet for ICICI_Bank_Current_Account_Thank_You_Page_Pageview
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/ica02+unique",
      });
    }
  }, []);

  const handleClick = () => {
    ctaClickEvent(
      "Back",
      "thank you page",
      "button",
      0,
      "https://campaigns.icici.bank.in/CA/customerInitiated/nca/index.html",
    );

    navigate("/");
  };

  return (
    <>
      <noscript>
        <img
          src="https://ad.doubleclick.net/ddm/activity/src=8971752;type=invmedia;cat=ica02;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1;num=1?"
          width="1"
          height="1"
          alt=""
        />
      </noscript>
      <section>
        <div className="container">
          <div className="thank-you">
            <div className="margin-top" style={{ position: "relative" }}>
              <h2 className="">Thank you for choosing ICICI Bank.</h2>
              <div className="popup-icon">
                <img
                  src={process.env.PUBLIC_URL + "/dist/img/icon15.webp"}
                  // src="dist/img/icon15.webp"
                  width="89"
                  height="89"
                  alt="Thanks"
                />
              </div>

              <h3>
                Our representative will get in touch with you shortly
                <br /> from a number starting with
                <br />
                <span>1600 31 XXXX</span>.
              </h3>

              <button
                href="/"
                onClick={handleClick}
                className="free_back thank_you_back"
              >
                Go back
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Thankyou;
